// ======================================================================
// File: FollowupKpiBar.jsx
// Purpose: KPI bar styled exactly like GRN reference
// ======================================================================

import React from "react";

export default function FollowupKpiBar({ items = [] }) {

  const total = items.length;

  const open = items.filter(x => x.status_code === "OPEN").length;
  const inProgress = items.filter(x => x.status_code === "IN_PROGRESS").length;
  const completed = items.filter(x => x.status_code === "COMPLETED").length;
  const cancelled = items.filter(x => x.status_code === "CANCELLED").length;

  const kpis = [
    { label: "Total", value: total, color: "#2563eb" },
    { label: "Open", value: open, color: "#16a34a" },
    { label: "In Progress", value: inProgress, color: "#d97706" },
    { label: "Completed", value: completed, color: "#6366f1" },
    { label: "Cancelled", value: cancelled, color: "#dc2626" },
  ];

  return (
    <div className="d-flex gap-3 mb-3">

      {kpis.map((k, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            padding: "14px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: "1px solid #e5e7eb"
          }}
        >
          <div>
            <div
              style={{
                fontSize: 13,
                color: "#6b7280",
                marginBottom: 2,
              }}
            >
              {k.label}
            </div>

            <h4
              style={{
                margin: 0,
                fontWeight: 600,
              }}
            >
              {k.value}
            </h4>
          </div>

          <div
            style={{
              width: 6,
              height: 38,
              borderRadius: 3,
              background: k.color,
            }}
          />
        </div>
      ))}

    </div>
  );
}
